// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pwl[data-v-59ccdd3c]{align-items:flex-start;display:flex;gap:15px;justify-content:space-between}.picture[data-v-59ccdd3c]{text-align:center}.link[data-v-59ccdd3c]{color:#3b3b3b;max-width:140px}img[data-v-59ccdd3c]{aspect-ratio:95/94;max-width:95px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
